import { IOfferCardProps } from '../../components/OfferCard';
import { mapThemBtn } from '../../constants/mapButtonThemes';
import { enrichOfferLinkWithParams } from './enrichOfferLinkWithParams';
import { IOfferBtnProps } from '../../components/OfferCard/components';
import { IOffer } from '../../repositories/mortgage-broker-calculator/entities/get_avaiable_multi_offers_v2/Offer';

export function transformOffers(
  rawOffer: IOffer,
  index: number,
  queryParams?: Record<string, string>,
): IOfferCardProps {
  const transformedOffer: IOfferCardProps = {
    title: {
      objectType: rawOffer.objectType,
      realEstateType: rawOffer.realEstateType,
      iconPath: rawOffer.bank.iconPath,
      name: rawOffer.bank.name,
      modalContent: rawOffer?.modal?.rows,
    },
    description: {
      text: rawOffer.description?.text,
      title: rawOffer.description?.title,
      links: rawOffer.description?.links,
    },
    conditions: {
      rate: rawOffer?.rate,
      income: rawOffer?.income,
      limit: rawOffer?.limit,
      monthlyPayment: rawOffer?.monthlyPayment,
      psk: rawOffer?.psk,
    },
    requirements: rawOffer.description?.requirements,
    promotion: {
      aboutAdvertiser: rawOffer.promotion?.aboutAdvertiser,
      bannerImgPaths: {
        imgPathDesktop: rawOffer.promotion?.picture.desktopUrl,
        imgPathMobile: rawOffer.promotion?.picture.mobileUrl,
        imgPathTablet: rawOffer.promotion?.picture.tabletUrl,
      },
    },
    labels: rawOffer.labels,
    placeOnList: index,
  };

  if (rawOffer.button) {
    const btnTheme = mapThemBtn[rawOffer.button.theme];
    const enrichedOfferLink = enrichOfferLinkWithParams(rawOffer.button.path, queryParams || {});

    transformedOffer['button'] = {
      text: rawOffer.button.text,
      path: enrichedOfferLink,
      theme: btnTheme,
      authorizationRequired: rawOffer.button.authorizationRequired,
      bankName: rawOffer.bank.name,
      analyticEventKey: rawOffer.button.analyticEventKey,
    } as IOfferBtnProps;
  }

  return transformedOffer;
}
